import user from './modules/user'
import enumList from './modules/commonEnum'
import toolEnum from './modules/tool'
import getters from './getters'
import { createStore } from 'vuex'

const store = createStore({
  modules: {
    user,
    enumList,
    toolEnum
  },
  getters,
})

export default store
